export default ({ label, up, down, children, ...props }) => {
  const onUp = useCallback((e) => {
    up(e, props)
  })

  const onDown = useCallback((e) => {
    down(e, props)
  })

  return (
    <div className="flex-1 text-center fcol">
      <div className="btn btn-primary" onClick={onUp}>
        <i className="ph ph-plus" />
      </div>
      <div className="flex-1">
        <div className="text-xs">{label}</div>
        {children}
      </div>
      <div className="btn btn-primary" onClick={onDown}>
        <i className="ph ph-minus" />
      </div>
    </div>
  )
}
